import {
    CONTACT_IMPORT_REPORT_CLOSE,
    CONTACT_IMPORT_REPORT_DOWNLOAD,
    CONTACT_IMPORT_REPORT_DOWNLOAD_DONE
} from './actionTypes';

export const contactImportReportClose = () => ({ type: CONTACT_IMPORT_REPORT_CLOSE });
export const contactImportReportDownload = () => ({ type: CONTACT_IMPORT_REPORT_DOWNLOAD });
export const contactImportReportDownloadDone = () => ({ type: CONTACT_IMPORT_REPORT_DOWNLOAD_DONE });
